import { GWPNew_Modal as Modal } from './GWP.new.Modal';
import { GWPNew_Product as Product } from './GWP.new.Product';
import { GWPNew_ColorPicker as ColorPicker } from './GWP.new.ColorPicker';
import { GWPNew_ProductSelector as ProductSelector } from './GWP.new.ProductSelector';
import { GWPNew_AddToCartButton as AddToCartButton } from './GWP.new.AddToCartButton';
import { GWPNew_CalloutButton as CalloutButton } from './GWP.new.CalloutButton';

export const GWPNewDesign = {
  Modal,
  Product,
  ColorPicker,
  ProductSelector,
  AddToCartButton,
  CalloutButton,
};
